import { DeliveryStatus, DeliveryStatuses } from 'src/constants/DeliveryStatus';

export function isPickedUpDelivery(deliveryStatus?: DeliveryStatus): boolean {
    return deliveryStatus === DeliveryStatuses.PICKED_UP;
}
